var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('clock-form',{attrs:{"clock":_vm.clock,"dirty":_vm.dirty,"editable":_vm.editable},on:{"update:dirty":function($event){_vm.dirty=$event},"delete":_vm.deleteClock,"update":_vm.updateClock}}),_vm._v(" "),_c('confirm',{ref:"confirm"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e853e40","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clock/clock-update.vue
// module id = null
// module chunks = 